import axios from 'axios';
import { API3_HOST } from '../../helpers/urlHelper';
import {
  baseGet,
  basePatchOnlyUrl,
} from 'services/base-services/baseService';
axios.defaults.withCredentials = true;

const baseUrl = `${API3_HOST}/sls-stock-movements`;

const isProductExisted = async (productID, desBinBarcode) => {
  return baseGet(
    `${baseUrl}/is-product-existed`,
    `?productId=${productID}&desBinBarcode=${desBinBarcode}`
  );
};

const stockCheck = async (stockId, qTy) => {
  return basePatchOnlyUrl(`${baseUrl}/${stockId}/stock-quantity`, { qTy });
};
const stockMove = async (request) => {
  return basePatchOnlyUrl(`${baseUrl}`, request);
};
const stockBulkMove = async (request) => {
  return basePatchOnlyUrl(`${baseUrl}/bulk-move`, request);
};

const stockBulkCheck = async (request) => {
  return basePatchOnlyUrl(`${baseUrl}/bulk-check`, request);
};

export { isProductExisted, stockCheck, stockMove, stockBulkMove, stockBulkCheck};
